export const hotelContract = {
    state: { //Contain data we want to use in our store, like data property of Vue Component
        contractData_ID: 0 //Use this ID select contract in update contract form
    }, 
    getters: { //Get data from our state

    }, 
    mutations: { //Function to change value of state (commit mutation), we can't trigger asyc code inside mutation.
        SET_CONTRACTDATA_ID(state, payload) {
          state.contractData_ID = payload  
        },
    }, 
    actions: { //Function to commit mutations, we can have async code in actions
        setContractData_ID({ commit }, value) {
            commit('SET_CONTRACTDATA_ID', value)
        },
    },
};